export const SEARCH_USERS = "SEARCH_USERS";

export default SEARCH_USERS;
